<script>
/**
 * Register component
 */
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      isRegisterError: false,
      registerSuccess: false
    };
  },
  props: {
    submitUrl: {
      type: String,
      required: true
    },
    regError: {
      type: String,
      required: false,
      default: () => null
    }
  },
  mounted() {
    this.isRegisterError = !!this.regError;
  }
};
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card overflow-hidden">
        <div class="bg-soft-primary">
          <div class="row">
            <div class="col-12 text-center">
              <img src="/images/Logo-Menu.png" alt class="img-fluid" style="width: 200px; height: auto;"/>
            </div>
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary"> Web!</h5>
                  <p>Registrate para continuar.</p>
                </div>
              </div>
            </div>
          </div>
        <div class="card-body pt-0">
          <b-alert
            v-model="registerSuccess"
            class="mt-3"
            variant="success"
            dismissible
          >Registro completo.
          </b-alert>

          <b-alert v-model="isRegisterError" class="mt-3" variant="danger" dismissible>{{regError}}</b-alert>

          <b-form class="p-2" :action="submitUrl" method="POST">
            <slot />
            <b-form-group id="email-group" label="Name" label-for="name">
              <b-form-input
                id="name"
                v-model="name"
                name="name"
                type="text"
                placeholder="Enter name"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="fullname-group" label="Email" label-for="email">
              <b-form-input
                id="email"
                name="email"
                v-model="email"
                type="email"
                placeholder="Enter email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="password-group" label="Password" label-for="password">
              <b-form-input
                id="password"
                v-model="password"
                name="password"
                type="password"
                placeholder="Enter password"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Confirm Password" label-for="password-confirm">
              <b-form-input
                id="password-confirm"
                v-model="password_confirmation"
                name="password_confirmation"
                type="password"
                placeholder="Confirm password"
              ></b-form-input>
            </b-form-group>

            <div class="mt-4">
              <b-button type="submit" variant="primary" class="btn-block">Registrate</b-button>
            </div>
          </b-form>
        </div>
        <!-- end card-body -->
      </div>
      <!-- end card -->
      <div class="mt-5 text-center">
        {{ new Date().getFullYear() }} © 
      </div>
    </div>
    <!-- end col -->
  </div>
</template>

<style lang="scss" module></style>
